<template>
  <ToastPrime position="bottom-left" />
  <nav id="navbarBlur" :class="`${!isNavFixed ? 'navbar navbar-main navbar-expand-lg px-0 mx-4 border-radius-xl shadow-none' : `navbar navbar-main navbar-expand-lg px-0 mx-4 border-radius-xl shadow-none position-sticky ${darkMode ? 'bg-default' : 'bg-white'} left-auto top-2 z-index-sticky` } ${isRTL ? 'top-0 position-sticky z-index-sticky' : ''}`" v-bind="$attrs" data-scroll="true">
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :key="$route.fullPath + ($route.meta.title || '')" :current-page="currentRouteName" :current-directory="currentDirectory" />
      <div
v-if="selectedModule !== 'Asset Management'" class="sidenav-toggler sidenav-toggler-inner d-xl-block d-none"
        :class="isRTL ? 'me-3' : ''">
        <a href="#" class="p-0 nav-link" @click.prevent="navbarMinimize">
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line" :class="isNavFixed && !darkMode ? ' opacity-8 bg-dark' : 'bg-white'"></i>
            <i class="sidenav-toggler-line" :class="isNavFixed && !darkMode ? ' opacity-8 bg-dark' : 'bg-white'"></i>
            <i class="sidenav-toggler-line" :class="isNavFixed && !darkMode ? ' opacity-8 bg-dark' : 'bg-white'"></i>
          </div>
        </a>
      </div>
      <div id="navbar" class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="isRTL ? 'px-0' : 'me-sm-4'">
        <div class="pe-md-3 d-flex align-items-center" :class="isRTL ? 'me-md-auto' : 'ms-md-auto'"></div>

        <!-- Module Selections -->
        <ul class="navbar-nav justify-content-end">
          <li class="nav-item dropdown d-flex align-items-center me-4">
            <a id="dropdownModuleButton" v-tooltip.bottom="'Module Selection'" href="#" class="p-0 nav-link" data-bs-toggle="dropdown"
              aria-expanded="false">
              <i class="cursor-pointer ni ni-app text-white"></i>
            </a>
            <ul class="dropdown-menu dropdown-menu-end" style="margin-top: 0 !important"
              aria-labelledby="dropdownModuleButton">
              <li class="mb-0">
                <a href="javascript:void(0)" class="dropdown-item"
                  @click="switchModule('Material Management', 'material-management')">
                  Material Management
                </a>
              </li>
              <li class="mb-0">
                <a href="javascript:void(0)" class="dropdown-item"
                  @click="switchModule('Asset Management', 'manage-assets')">
                  Asset Management
                </a>
              </li>
            </ul>
          </li>
        </ul>

        <!-- Advance Search -->
        <ul class="navbar-nav justify-content-end">
          <li class="nav-item dropdown d-flex align-items-center me-4">
            <!-- Pakai <button>, bukan <a href>, supaya klik kanan tidak memunculkan "Open link in new tab" -->
            <button id="dropdownSearchButton" v-tooltip.bottom="'Advance Search'" type="button"
              class="p-0 nav-link bg-transparent border-0" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="cursor-pointer fa fa-search text-white"></i>
            </button>
            <ul class="dropdown-menu dropdown-menu-end" style="margin-top: 0 !important"
              aria-labelledby="dropdownSearchButton">
              <li class="mb-0">
                <button type="button" class="dropdown-item" @click="showAdvanceSearchDialog = true">
                  Advance Search Material
                </button>
              </li>
              <li class="mb-0">
                <button type="button" class="dropdown-item" @click="showAdvanceSearchServiceDialog = true">
                  Advance Search Service
                </button>
              </li>
              <li class="mb-0">
                <button type="button" class="dropdown-item" @click="showAdvanceSearchCharacteristicDialog = true">
                  Search By Characteristics
                </button>
              </li>
            </ul>
          </li>
        </ul>

        <ul class="navbar-nav justify-content-end">
          <li class="nav-item dropdown d-flex align-items-center me-4">
            <a id="dropdownMenuButton" v-tooltip.bottom="'Notifications'" href="#" class="p-0 nav-link" data-bs-toggle="dropdown"
              aria-expanded="false" @click="showMenu = !showMenu" @blur="closeMenu">
              <i class="cursor-pointer fa fa-bell text-white"></i>
              <span v-if="unreadCount > 0" class="badge bg-danger" style="font-size: 0.7rem; padding: 0.2rem 0.5rem">{{
                unreadCount }}</span>
            </a>
            <ul class="dropdown-menu dropdown-menu-end" style="margin-top: 0 !important"
              aria-labelledby="dropdownMenuButton">
              <li v-if="loadingNotifications" class="mb-2">
                <p class="dropdown-item border-radius-md">Loading...</p>
              </li>
              <li v-else-if="notifications.length === 0" class="mb-2">
                <p class="dropdown-item border-radius-md">No notifications</p>
              </li>
              <li v-for="notification in notifications.slice(0, 5)" v-else :key="notification.id" class="mb-2"
                :style="{ cursor: isHovered ? 'pointer' : 'default' }" @click="handleNotification(notification)" @mouseenter="isHovered = true"
                @mouseleave="isHovered = false">
                <a class="dropdown-item border-radius-md" href="#">
                  <div class="py-1 d-flex">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        <span class="font-weight-bold">Notification</span> • {{ notification.notifiable_type ||
                          'General' }}
                      </h6>
                      <h6 class="mb-1 text-sm font-weight-normal">
                        {{ truncateMessage(notification.data.message || 'No additional details') }}
                      </h6>
                      <p class="mb-0 text-xs text-secondary">
                        <i class="fa fa-clock me-1"></i>
                        {{ formatDateTime(notification.created_at) }}
                      </p>
                    </div>
                  </div>
                </a>
              </li>
              <li class="mb-2">
                <router-link to="/dashboards/my-notification" class="dropdown-item text-center">
                  See All Notifications
                </router-link>
              </li>
            </ul>
          </li>
        </ul>

        <ul class="navbar-nav justify-content-end">
          <li class="nav-item d-flex align-items-center me-4">
            <a v-tooltip.bottom="'Notes'" href="#" class="p-0 nav-link" @click.prevent="openNoteDrawer">
              <i class="cursor-pointer fa fa-sticky-note text-white"></i>
            </a>
          </li>
        </ul>

        <ul class="navbar-nav justify-content-end">
          <li class="nav-item dropdown d-flex align-items-center">
            <a
id="profileDropdown" class="nav-link font-weight-bold px-0 d-flex align-items-center" href="#"
              role="button" data-bs-toggle="dropdown" aria-expanded="false"
              :class="isNavFixed && !darkMode ? 'opacity-8 text-dark' : 'text-white'">
              <img
v-if="userImage" :src="userImage" alt="User Image" class="rounded-circle me-2"
                style="width: 30px; height: 30px" />
              <div v-else class="rounded-circle me-2" style="width: 30px; height: 30px; background-color: #d1d1d1;">
                <i class="fa fa-user text-white" style="line-height: 30px; text-align: center; width: 100%;"></i>
              </div>

              <span>{{ name }}</span>
            </a>

            <ul
class="dropdown-menu dropdown-menu-end" style="margin-top: 0 !important"
              aria-labelledby="profileDropdown">
              <li>
                <router-link class="dropdown-item" to="/profile">Profile</router-link>
              </li>
              <li>
                <a class="dropdown-item" href="#" @click.prevent="logoutUser">Logout</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <!-- Note Drawer -->
  <Sidebar
v-model:visible="showNoteDrawer" position="right" :modal="false" class="note-drawer"
    :style="{ width: '350px' }">
    <template #header>
      <h5 class="mb-0">
        <i class="fa fa-sticky-note me-2"></i>
        Notes
      </h5>
    </template>

    <div class="note-content">
      <!-- Note Editor Form -->
      <div v-if="showNoteEditor" class="note-editor">
        <div class="mb-3">
          <label class="form-label">Title</label>
          <InputText
v-model="editingNote.title" placeholder="Enter note title"
            :class="`w-100 ${validationErrors.title ? 'border-danger' : ''}`" @input="validateField('title')" />
          <small v-if="validationErrors.title" class="text-danger">Title is required</small>
        </div>
        <div class="mb-3">
          <label class="form-label">Content</label>
          <PrimeTextarea
v-model="editingNote.note" placeholder="Enter note content" rows="5"
            :class="`w-100 ${validationErrors.note ? 'border-danger' : ''}`" @input="validateField('note')" />
          <small v-if="validationErrors.note" class="text-danger">Content is required</small>
        </div>
        <div class="mb-3">
          <ButtonPrime label="Cancel" class="me-2" severity="secondary" :disabled="savingNote" @click="cancelEdit" />
          <ButtonPrime label="Save" severity="success" :loading="savingNote" @click="saveNote" />
        </div>
      </div>

      <!-- Notes List -->
      <div v-else>
        <div class="mb-3">
          <button class="btn btn-sm btn-primary  w-100" @click="addNewNote">
            Add New Note
          </button>
        </div>

        <div v-if="loadingNotes" class="notes-skeleton">
          <div v-for="n in 5" :key="'skeleton-' + n" class="skeleton-item mb-3 p-3 border rounded">
            <div class="d-flex justify-content-between align-items-start mb-1">
              <div class="skeleton-title"></div>
              <div class="skeleton-actions">
                <div class="skeleton-action-btn me-1"></div>
                <div class="skeleton-action-btn"></div>
              </div>
            </div>
            <div class="skeleton-content mb-1"></div>
            <div class="skeleton-date"></div>
          </div>
        </div>

        <div v-else-if="notes.length === 0" class="text-center py-4">
          <i class="fa fa-sticky-note fa-3x text-muted mb-3"></i>
          <p class="text-muted">No notes yet. Click "Add New Note" to create one.</p>
        </div>

        <div v-else class="notes-list">
          <div
v-for="(note, index) in notes" :key="note.id" class="note-item mb-2 p-3 border rounded"
            :class="{ 'border-primary bg-light': note.isActive }">
            <div class="d-flex justify-content-between align-items-start">
              <div class="note-content-wrapper">
                <!-- Inline editing mode -->
                <div v-if="editingIndex === index">
                  <div class="mb-2">
                    <input
v-model="editingNote.title" type="text" class="form-control form-control-sm mb-2"
                      :class="{ 'is-invalid': validationErrors.title }" placeholder="Title" @blur="finishEditing(index)"
                      @keyup.enter="finishEditing(index)" @keyup.esc="cancelInlineEdit" />
                    <textarea
v-model="editingNote.note" class="form-control form-control-sm" rows="3"
                      :class="{ 'is-invalid': validationErrors.note }" placeholder="Content"
                      @blur="finishEditing(index)" @keyup.enter="finishEditing(index)"
                      @keyup.esc="cancelInlineEdit"></textarea>
                    <div v-if="validationErrors.title" class="invalid-feedback">
                      Title is required
                    </div>
                    <div v-if="validationErrors.note" class="invalid-feedback">
                      Content is required
                    </div>
                  </div>
                  <div class="d-flex">
                    <button class="btn btn-sm btn-success me-1" :disabled="savingNote" @click="finishEditing(index)">
                      <i v-if="!savingNote" class="fa fa-check"></i>
                      <i v-else class="fa fa-spinner fa-spin"></i>
                    </button>
                    <button class="btn btn-sm btn-secondary" :disabled="savingNote" @click="cancelInlineEdit">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
                <!-- Display mode -->
                <div v-else @click="viewNote(note)">
                  <h6 class="note-title mb-1" @dblclick="startInlineEdit(index, note)">{{ note.title || 'Untitled Note'
                  }}
                  </h6>
                  <p class="note-text mb-1 text-muted small" @dblclick="startInlineEdit(index, note)">{{ note.note ||
                    'No content' }}</p>
                  <small class="note-date text-muted">
                    <i class="fa fa-clock me-1"></i>
                    {{ formatDateTime(note.created_at) }}
                  </small>
                </div>
              </div>
              <div class="note-actions d-flex flex-column" @click.stop>
                <button class="btn btn-sm btn-outline-primary mb-1" title="Edit" @click="startInlineEdit(index, note)">
                  <i class="fa fa-edit"></i>
                </button>
                <button class="btn btn-sm btn-outline-danger" title="Delete" @click="deleteNote(index)">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Sidebar>

  <!-- Advance Search Material Popup -->
  <DialogPrime
v-model:visible="showAdvanceSearchDialog" modal :style="{ width: '900px' }"
    :breakpoints="{ '960px': '95vw' }">
    <template #header>
      <h5 class="mb-0">ADVANCE SEARCH MATERIAL</h5>
    </template>
    <MaterialSearchForm @submit="onPopupSearch" />
  </DialogPrime>

  <!-- Advance Search Service Popup -->
  <DialogPrime
v-model:visible="showAdvanceSearchServiceDialog" modal :style="{ width: '900px' }"
    :breakpoints="{ '960px': '95vw' }">
    <template #header>
      <h5 class="mb-0">ADVANCE SEARCH SERVICE</h5>
    </template>
    <ServiceSearchForm @submit="onServiceSearch" />
  </DialogPrime>

  <!-- Search By Characteristic Popup -->
  <DialogPrime
v-model:visible="showAdvanceSearchCharacteristicDialog" modal :style="{ width: '900px' }"
    :breakpoints="{ '960px': '95vw' }">
    <template #header>
      <h5 class="mb-0">SEARCH BY CHARACTERISTIC & VALUE</h5>
    </template>
    <CharacteristicSearchForm @submit="onCharacteristicSearch" />
  </DialogPrime>
</template>

<script>
import moment from "moment";
import Breadcrumbs from "./Breadcrumbs.vue";
import { mapState, mapMutations } from "vuex";
import myNotificationService from "@/services/dashboards/myNotificationService";
import config from "@/configs/config";
import authService from "@/services/authService";
import api from "@/helpers/api";
import noteService from "@/services/dashboards/noteService";
import MaterialSearchForm from "@/views/generalLayout/MaterialSearchForm.vue";
import ServiceSearchForm from "@/views/generalLayout/ServiceSearchForm.vue";
import CharacteristicSearchForm from "@/views/generalLayout/CharacteristicSearchForm.vue";

export default {
  components: {
    Breadcrumbs,
    MaterialSearchForm,
    ServiceSearchForm,
    CharacteristicSearchForm,
  },
  data() {
    return {
      showMenu: false,
      showAdvanceSearchDialog: false,
      showAdvanceSearchServiceDialog: false,
      showAdvanceSearchCharacteristicDialog: false,
      notifications: [],
      loadingNotifications: false,
      unreadCount: 0,
      apiUrl: config.storageUrl,
      errorMessage: {},
      userProfile: null,
      showNoteDrawer: false,
      showNoteEditor: false,
      notes: [],
      loadingNotes: false,
      savingNote: false, // untuk loading saat save/edit note
      editingNote: {
        title: '',
        note: '',
        createdAt: null
      },
      editingIndex: -1,
      validationErrors: {
        title: false,
        note: false
      }
    };
  },
  computed: {
    ...mapState({
      isRTL: (state) => state.argonConfig.isRTL,
      isNavFixed: (state) => state.argonConfig.isNavFixed,
      darkMode: (state) => state.argonConfig.darkMode,
    }),
    name() {
      const localUser = JSON.parse(localStorage.getItem('userAuth') || '{}')?.user;
      return this.userProfile?.name || this.$store?.state?.auth?.user?.name || localUser?.name || "Guest";
    },
    userImage() {
      const localUser = JSON.parse(localStorage.getItem('userAuth') || '{}')?.user;
      const user_image = this.userProfile?.image || localUser?.image;
      return user_image ? `${config.storageUrl}/${user_image}` : "";
    },
    currentRouteName() {
      const pathArray = this.$route.path.split("/").filter(Boolean);
      const filteredPath = pathArray.filter(segment => !['material-management', 'manage-assets'].includes(segment));
      return [filteredPath, this.$route.name, this.$route];
    },
    currentDirectory() {
      if (this.selectedModule === 'Asset Management') {
        return "Assets Management";
      }
      const pathArray = this.$route.path.split("/").filter(Boolean);
      // The actual directory is now the first segment after moduleSlug
      // pathArray[0] is moduleSlug, pathArray[1] is the directory
      let dir = pathArray.length > 1 ? pathArray[1] : (pathArray[0] || "");
      // If the first segment is already a module slug, and there's no second, use the slug or empty
      if (['material-management', 'manage-assets'].includes(pathArray[0]) && pathArray.length === 1) {
        dir = "";
      }
      return dir.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
    },
    selectedModule() {
      const slug = this.$route.params.moduleSlug;
      if (slug === 'material-management') return 'Material Management';
      if (slug === 'manage-assets') return 'Asset Management';
      return this.$store.state.auth.selectedModule;
    },
  },
  methods: {
    ...mapMutations({
      navbarMinimize: "argonConfig/navbarMinimize",
    }),
    switchModule(moduleName, slug) {
      this.$store.commit("auth/setSelectedModule", moduleName);
      let targetRoute = { name: 'Home', params: { moduleSlug: slug } };

      // If switching to Asset Management, go directly to Manage Assets
      if (slug === 'manage-assets') {
        targetRoute = { name: 'Manage Assets', params: { moduleSlug: slug } };
      }

      this.$router.push(targetRoute).then(() => {
        // Full reload to ensure layout and sidenav items re-render correctly
        window.location.reload();
      });
    },
    // Handle submit dari popup Advance Search: tutup dialog, navigasi ke
    // halaman Search Material dengan filter sebagai query (loadFromURL yang
    // menjalankan pencarian di halaman tujuan).
    onPopupSearch(params) {
      this.showAdvanceSearchDialog = false;
      this.$router.push({
        name: 'Search Material',
        params: { moduleSlug: this.$route.params.moduleSlug || 'material-management' },
        query: params,
      });
    },
    // Submit dari popup Advance Search Service -> tutup dialog & navigasi ke
    // halaman Advance Search Service dengan filter sebagai query (loadFromURL
    // yang menjalankan pencarian di halaman tujuan).
    onServiceSearch(params) {
      this.showAdvanceSearchServiceDialog = false;
      this.$router.push({
        name: 'Advance Search Service',
        params: { moduleSlug: this.$route.params.moduleSlug || 'material-management' },
        query: params,
      });
    },
    // Submit dari popup Search By Characteristic. Modal sudah memanggil endpoint
    // search sendiri dan mengirim { payload, result, error }. Di sini kita tutup
    // dialog lalu navigasi ke halaman hasil dengan filter (payload) sebagai query
    // agar konsisten dengan form pencarian lain.
    onCharacteristicSearch(payload) {
      this.showAdvanceSearchCharacteristicDialog = false;
      const query = { ...payload };
      // characteristics berupa array of object -> stringify agar aman lewat query URL
      // (vue-router cuma bisa serialize primitif/array primitif, bukan array of object).
      if (Array.isArray(query.characteristics)) {
        query.characteristics = JSON.stringify(query.characteristics);
      }
      this.$router.push({
        name: 'Search By Characteristic',
        params: { moduleSlug: this.$route.params.moduleSlug || 'material-management' },
        query,
      });
    },
    closeMenu() {
      setTimeout(() => {
        this.showMenu = false;
      }, 100);
    },
    truncateMessage(message, maxLength = 50) {
      if (message.length > maxLength) {
        return message.slice(0, maxLength) + "..."; // Memotong pesan dan menambahkan elipsis
      }
      return message; // Mengembalikan pesan utuh jika panjangnya sesuai
    },
    formatDateTime(time) {
      return moment(time).format("DD/MM/YYYY HH:mm");
    },
    async fetchNotifications() {
      this.loadingNotifications = true;
      try {
        const response = await api(this, myNotificationService.navbar(), false);
        const items = Array.isArray(response?.data) ? response.data : [];
        this.notifications = items;
        this.unreadCount = items.filter(n => !n.read_at).length;
      } catch (error) {
        // console.error("Error fetching notifications:", error);
        const errorMessage = error.response?.data?.message || 'Failed to fetch notifications';
        this.$toastNotifPrime('error', 'Error', errorMessage);
      } finally {
        this.loadingNotifications = false;
      }
    },
    async fetchUserProfile() {
      try {
        const response = await api(this, authService.getNavbarProfile(), false);
        if (response && response.data) {
          this.userProfile = response.data;
        }
      } catch (error) {
        // console.error("Error fetching user profile:", error);
        const errorMessage = error.response?.data?.message || 'Failed to fetch user profile';
        this.$toastNotifPrime('error', 'Error', errorMessage);        
      }
    },
    checkLoginAndFetchNotifications() {
      // Skip if on login page
      if (this.$route.path === '/login') {
        return;
      }

      const userAuth = JSON.parse(localStorage.getItem('userAuth') || '{}');
      const authenticated = this.$store?.state?.auth?.authenticated || userAuth?.authenticated;
      if (authenticated) {
        if (!this.userProfile && userAuth?.user) {
          this.userProfile = userAuth.user;
        }
        this.fetchNotifications();
        this.fetchUserProfile();
      } else {
        // Reset user profile if no token
        this.userProfile = null;
      }
    },
    async logoutUser() {
      try {
        await api(this, authService.logout(), false);
      } catch (error) {
        // console.error("Error calling logout endpoint:", error);
        const errorMessage = error.response?.data?.message || 'Failed to logout';
        this.$toastNotifPrime('error', 'Error', errorMessage);
        return;
      } finally {
        this.$store.dispatch("auth/logout");
        window.location = "/login";
      }
    },
    async handleNotification(notification) {
      const { id, data } = notification;
      const message_notif = data?.message || '';
      const moduleSlug = this.$route.params.moduleSlug || 'material-management';

      try {
        await api(this, myNotificationService.read(id), false);
        const afterRead = this.notifications.filter((note) => note.id !== id);
        this.notifications = afterRead;
        this.unreadCount = afterRead.filter(n => !n.read_at).length;

        if (message_notif.startsWith("Please make an approval") || message_notif.startsWith("Please make approval")) {
          const routeApprov = {
            name: "MCR Form for My Task MCR",
            params: { moduleSlug, id: data.source.id, action: 'approval', mcrCode: data.source.mcr_code }
          };
          const routeData = this.$router.resolve(routeApprov);
          window.open(routeData.href, "_blank");
        } else if (message_notif.startsWith("Your order") && (message_notif.includes("has been approved") || message_notif.includes("has been rejected"))) {
          const routes = this.$router.resolve({
            name: 'MCR Form for Material Request',
            params: { moduleSlug, id: data.source.id, action: "edit", mcrCode: data.source.mcr_code }
          });
          const routeData = this.$router.resolve(routes);
          window.open(routeData.href, "_blank")
        } else {
          this.$router.push({ name: "My Task", params: { moduleSlug } });
        }

      } catch (error) {
        if (error.response?.data?.code == 400) {
          error.response.data.data.forEach((v) => {
            this.errorMessage[v.path] = v.msg;
          });
        } else if (error.response?.data?.message) {
          this.errorMessage[0] = error.response.data.message || 'Something went wrong';
        }
      }
    },

    // Note management methods
    async loadNotes() {
      this.loadingNotes = true;
      try {
        const response = await api(this, noteService.list(), false);
        console.log('Notes response:', response);

        // Check different possible response structures
        if (response && response.data) {
          if (response.data.data) {
            // Structure: { data: { data: [...] } }
            this.notes = response.data.data;
          } else if (Array.isArray(response.data)) {
            // Structure: { data: [...] }
            this.notes = response.data;
          }
          console.log('Notes loaded:', this.notes);
        }
      } catch (error) {
        // console.error("Error fetching notes:", error);
        const errorMessage = error.response?.data?.message || 'Failed to fetch notes';
        this.$toastNotifPrime('error', 'Error', errorMessage);  
      } finally {
        this.loadingNotes = false;
      }
    },

    addNewNote() {
      this.editingNote = {
        title: '',
        note: '',
        createdAt: new Date().toISOString()
      };
      this.editingIndex = -1;
      this.resetValidation();
      this.showNoteEditor = true;
    },

    startInlineEdit(index, note) {
      this.editingNote = { ...note };
      this.editingIndex = index;
      this.resetValidation();
      // Tidak perlu memanggil loadNotes lagi karena kita langsung gunakan data lokal
    },

    async finishEditing(index) {
      // Validate all fields
      this.validateAllFields();

      if (this.validationErrors.title || this.validationErrors.note) {
        this.$toastNotifPrime('error', 'Error', 'Please fill in all required fields');
        return;
      }

      this.savingNote = true; // Aktifkan loading saat menyimpan

      try {
        const noteData = {
          title: this.editingNote.title,
          note: this.editingNote.note
        };

        const note = this.notes[index];
        const response = await api(this, noteService.patch(note.id, noteData), true);

        if (response && response.data) {
          // Update the local note data immediately after successful API call
          this.notes[index] = { ...this.editingNote, id: note.id };
        }

        this.editingIndex = -1; // Keluar dari mode edit
      } catch (error) {
        // console.error("Error saving note:", error);
        const errorMessage = error.response?.data?.message || 'Failed to save note';
        this.$toastNotifPrime('error', 'Error', errorMessage); 
      } finally {
        this.savingNote = false; // Nonaktifkan loading setelah selesai
      }
    },

    cancelInlineEdit() {
      this.editingIndex = -1;
      this.resetValidation();
    },

    editNote(index) {
      const note = this.notes[index];
      if (note) {
        this.editingNote = { ...note };
        this.editingIndex = index;
        this.resetValidation();
        this.showNoteEditor = true;
      }
    },

    async deleteNote(index) {
      this.confirmDialog("You won't be able to revert this!", "delete it").then((result) => {
        if (result.isConfirmed) {
          api(this, noteService.delete(this.notes[index].id), true).then(() => {
            this.notes.splice(index, 1);
          });
        }
      });
    },

    async saveNote() {
      // Validate all fields
      this.validateAllFields();

      if (this.validationErrors.title || this.validationErrors.note) {
        this.$toastNotifPrime('error', 'Error', 'Please fill in all required fields');
        return;
      }

      this.savingNote = true; // Aktifkan loading saat menyimpan

      try {
        const noteData = {
          title: this.editingNote.title,
          note: this.editingNote.note
        };

        if (this.editingIndex === -1) {
          // Add new note
          const response = await api(this, noteService.create(noteData), true);

          if (response && response.data) {
            // Handle different response structures
            let newNote;
            if (response.data.data) {
              newNote = response.data.data;
            } else if (response.data.id) {
              newNote = response.data;
            }

            if (newNote) {
              this.notes.unshift(newNote);
              this.$toastNotifPrime('success', 'Success', 'Note created successfully');
            }
          }
        } else {
          // Update existing note
          const note = this.notes[this.editingIndex];
          const response = await api(this, noteService.patch(note.id, noteData), true);

          if (response && response.data) {
            // Update the local note data immediately after successful API call
            this.notes[this.editingIndex] = { ...this.editingNote, id: note.id };
            this.$toastNotifPrime('success', 'Success', 'Note updated successfully');
          }
        }

        this.showNoteEditor = false;
        // Ensure drawer stays open
        this.showNoteDrawer = true;
      } catch (error) {
        // console.error("Error saving note:", error);
        const errorMessage = error.response?.data?.message || 'Failed to save note';
        this.$toastNotifPrime('error', 'Error', errorMessage);
      } finally {
        this.savingNote = false; // Nonaktifkan loading setelah selesai
      }
    },

    openNoteDrawer() {
      this.showNoteDrawer = true;
      console.log('Opening note drawer...');
      this.loadNotes(); // Refresh notes when drawer opens
    },

    viewNote(note) {
      // Set active note
      this.notes.forEach(n => n.isActive = false);
      note.isActive = true;

      // You can add additional logic here, like showing note details
      console.log('Viewing note:', note);
    },

    cancelEdit() {
      this.showNoteEditor = false;
      this.resetValidation();
      // Ensure drawer stays open
      this.showNoteDrawer = true;
    },

    validateField(field) {
      if (field === 'title') {
        this.validationErrors.title = !this.editingNote.title.trim();
      } else if (field === 'note') {
        this.validationErrors.note = !this.editingNote.note.trim();
      }
    },

    validateAllFields() {
      this.validationErrors.title = !this.editingNote.title.trim();
      this.validationErrors.note = !this.editingNote.note.trim();
    },

    resetValidation() {
      this.validationErrors.title = false;
      this.validationErrors.note = false;
    },

    confirmDialog(message) {
      return this.$swal({
        title: 'Are you sure?',
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      });
    },
  },
  watch: {
    '$route.meta.title'() {
      // Force re-render when route meta title changes
      this.$forceUpdate();
    }
  },
  mounted() {
    if (!this.userProfile && this.$store?.state?.auth?.user?.name) {
      this.userProfile = this.$store.state.auth.user;
    }
    this.checkLoginAndFetchNotifications();
    if (window.innerWidth < 1200) {
      this.navbarMinimize();
    }
    // Listen for meta update event
    window.addEventListener('route-meta-updated', () => {
      this.$forceUpdate();
    });
    // Listen for profile update event
    window.addEventListener('user-profile-updated', () => {
      this.fetchUserProfile();
    });
  },
  beforeUnmount() {
    window.removeEventListener('user-profile-updated', this.fetchUserProfile);
  },
};
</script>
<style>
.nav-item.dropdown .nav-link.dropdown-toggle::after,
.nav-item.dropdown .dropdown-menu::before {
  content: none;
}

/* Note Drawer Styles */
.note-drawer .p-sidebar-content {
  padding: 1rem;
}

.note-content {
  height: calc(100vh - 120px);
  overflow-y: auto;
}

.note-item {
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
}

.note-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.note-item.border-primary {
  border-color: #5e72e4 !important;
  background-color: rgba(94, 114, 228, 0.05);
}

.note-content-wrapper {
  flex: 1;
  margin-right: 0.75rem;
}

.note-title {
  font-weight: 500;
  color: #333;
  font-size: 0.95rem;
  line-height: 1.3;
}

.note-text {
  color: #666;
  font-size: 0.85rem;
  line-height: 1.4;
  margin-bottom: 0.25rem;
}

.note-date {
  font-size: 0.75rem;
  color: #999;
}

.note-actions {
  opacity: 0;
  transition: opacity 0.3s ease;
  flex-shrink: 0;
}

.note-item:hover .note-actions {
  opacity: 1;
}

.note-actions .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  margin-bottom: 0.25rem;
}

.note-actions .btn:last-child {
  margin-bottom: 0;
}

.note-actions {
  z-index: 10;
  position: relative;
}

.note-actions {
  opacity: 0;
  transition: opacity 0.3s ease;
}

.note-item:hover .note-actions {
  opacity: 1;
}

.note-actions .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.note-actions {
  z-index: 10;
  position: relative;
}

/* Note Editor Form Styles */
.note-editor {
  padding: 0.75rem 0;
}

.note-editor .mb-3 {
  margin-bottom: 1rem;
}

.note-editor .form-label {
  display: block;
  margin-bottom: 0.25rem;
  font-weight: 500;
}

.note-editor InputText,
.note-editor PrimeTextarea {
  width: 100%;
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  font-size: 1rem;
}

.note-editor InputText {
  height: calc(1.5em + 0.75rem + 2px);
}

.note-editor .text-danger {
  color: #dc3545;
  font-size: 0.875em;
  margin-top: 0.25rem;
  display: block;
}

/* Skeleton Loading Styles */
.skeleton-item {
  background: #f0f0f0;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 12px;
  animation: skeleton-pulse 1.5s infinite ease-in-out;
}

.skeleton-title {
  height: 20px;
  width: 60%;
  background: #e0e0e0;
  border-radius: 4px;
  margin-bottom: 8px;
}

.skeleton-content {
  height: 16px;
  width: 100%;
  background: #e0e0e0;
  border-radius: 4px;
  margin-bottom: 8px;
}

.skeleton-content:nth-child(2n) {
  width: 80%;
}

.skeleton-date {
  height: 14px;
  width: 40%;
  background: #e0e0e0;
  border-radius: 4px;
}

.skeleton-actions {
  display: flex;
}

.skeleton-action-btn {
  width: 24px;
  height: 24px;
  background: #e0e0e0;
  border-radius: 3px;
  margin-left: 4px;
}

@keyframes skeleton-pulse {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }

  100% {
    opacity: 1;
  }
}

/* PrimeVue Sidebar customization */
.p-sidebar-right {
  z-index: 1000;
}

.p-sidebar .p-sidebar-header {
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 1rem;
}

.p-sidebar .p-sidebar-content {
  background: #fff;
}

/* Ensure dialog doesn't interfere with drawer */
.p-dialog {
  z-index: 1001 !important;
}

.p-dialog-mask {
  z-index: 1000 !important;
}
</style>
